import {SchemasOrderSaleSettle} from '@shared/schemas/order'

type ApiSet<Request, Response> = {
    request: Request
    response: Response
}

/** 정산내역 조회 */
export type FetchSettlementHistory = ApiSet<
    SchemasOrderSaleSettle['/']['request'],
    SchemasOrderSaleSettle['/']['response']
>

/** 정산내역 > 정산요약 조회 */
export type FetchSettlementSummary = ApiSet<
    SchemasOrderSaleSettle['/summary']['request'],
    SchemasOrderSaleSettle['/summary']['response']
>

/** 정산상세 조회 */
export type FetchSettlementDetail = ApiSet<
    {
        /** 정산대상번호 */
        settleObjectNo: string
    },
    SchemasOrderSaleSettle['/:settleObjectNo']['response']
>

export const ErrorCode = {
    /** 유효하지 않은 정산번호 */
    INVALID_SETTLEMENT_NO: 'INVALID_SETTLEMENT_NO',
} as const

/** 지급보류 타입 */
export const PayHoldType = {
    /** 보류신청 */
    HOLD_REQUEST: 'HOLD_REQUEST',
    /** 보류완료 */
    CONFIG: 'CONFIG',
    /** 보류완료 해제 */
    RELEASE: 'RELEASE',
    /** 보류미완료 취소 */
    CANCEL: 'CANCEL',
} as const
/** 지급보류 타입 */
export type PayHoldTypeType = Constant<typeof PayHoldType>

/** 지급보류 사유 타입 */
export const PayHoldReasonType = {
    /** 분쟁대응 */
    RM_REGIST_BOND: 'RM_REGIST_BOND',
    /** 상표권대응 */
    TRADEMARK_RIGHTS: 'TRADEMARK_RIGHTS',
    /** 채권압류 */
    GARNISHMENT: 'GARNISHMENT',
    /** 부정거래 */
    ILLEGAL_DEAL: 'ILLEGAL_DEAL',
    /** 예약운영 */
    RESERVATION_OPERATE: 'RESERVATION_OPERATE',
    /** 건강보험공단 */
    HEALTH_INSURANCE: 'HEALTH_INSURANCE',
    /** 기타 */
    ETC: 'ETC',
} as const
/** 지급보류 사유 타입 */
export type PayHoldReasonTypeType = Constant<typeof PayHoldReasonType>
